import React from 'react';
import Slider from "react-slick";
import styles from "./css/FranchiseNewsArticles.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const newsData = [
  {
    image: "https://www.schooldekho.org/storage/uploads/images/i2m1pbh9ffccks8okwoogs8kwssw4cg.jpg",
    title: "Apple Unveils iOS 19 with AI Features",
    description: "iOS 19 brings AI to Siri, Messages, and more."
  },
  {
    image: "https://www.schooldekho.org/storage/uploads/images/i2m1pbh9ffccks8okwoogs8kwssw4cg.jpg",
    title: "Quantum Computer in India",
    description: "ISRO and IIT Madras launch quantum breakthrough."
  },
  {
    image: "https://www.schooldekho.org/storage/uploads/images/i2m1pbh9ffccks8okwoogs8kwssw4cg.jpg",
    title: "Markets Rally on Economic Data",
    description: "Global markets respond to positive indicators."
  },
  {
    image: "https://www.schooldekho.org/storage/uploads/images/i2m1pbh9ffccks8okwoogs8kwssw4cg.jpg",
    title: "OpenAI Releases GPT-5",
    description: "GPT-5 preview released for research community."
  },
  {
    image: "https://www.schooldekho.org/storage/uploads/images/i2m1pbh9ffccks8okwoogs8kwssw4cg.jpg",
    title: "SpaceX Launches 100th Rocket",
    description: "Another successful mission by SpaceX this year."
  },
  {
    image: "https://www.schooldekho.org/storage/uploads/images/i2m1pbh9ffccks8okwoogs8kwssw4cg.jpg",
    title: "Google Introduces Search AI",
    description: "New generative AI changes how we search forever."
  }
];

export default function FranchiseNewsArticles() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,          // ✅ enable auto-slide
    autoplaySpeed: 2000,     // ✅ time (ms) between slides (2s here)
    pauseOnHover: true,      // ✅ optional (pause when hovered)
    responsive: [
      {
        breakpoint: 1024, // Tablet
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768, // Mobile
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };

  return (
    <div className={styles.container}>
      
      <h3 className={styles.heading}>News Articles</h3>
      <div className={styles.sliderWrapper}>
        <Slider {...settings}>
          {newsData.map((item, index) => (
            <div key={index} className={styles.cardWrapper}>
              <div className={styles.newsCard}>
                <img src={item.image} alt="News" className={styles.newsImage} />
                <h3 className={styles.newsTitle}>{item.title}</h3>
                <p className={styles.newsDescription}>{item.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
